import { render, staticRenderFns } from "./ProgramCustomizationNavbar.vue?vue&type=template&id=1b3dd376&lang=pug&"
import script from "./ProgramCustomizationNavbar.vue?vue&type=script&lang=js&"
export * from "./ProgramCustomizationNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ProgramCustomizationNavbar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports